import type { UnknownProps } from "app/pages/sales-intelligence/types";
import type { ComponentType } from "react";
import type { MutateOptions } from "@tanstack/react-query";

import type { DigestSubscription, UpdateDigestSubscriptionDTO } from "../sub-modules/signals-alerts/models/DigestSubscription";
import EmailUnsubscribeModalContainer from "../sub-modules/signals-alerts/containers/EmailUnsubscribeModal/EmailUnsubscribeModalContainer";
import useSignalsAlertsCancellationMutation from "../sub-modules/signals-alerts/query/mutations/useSignalsAlertsCancellationMutation";

const withSignalsSubscription = <P extends UnknownProps>(Component: ComponentType<P>) => {
    return function WrappedWithSignalsSubscription(props: P) {
        const signalsAlertsCancellationMutation = useSignalsAlertsCancellationMutation();

        const handleConfirmUnsubscribe = (dto: UpdateDigestSubscriptionDTO, options: Readonly<MutateOptions<DigestSubscription, unknown, UpdateDigestSubscriptionDTO>>) => {
            signalsAlertsCancellationMutation.mutate(dto, options);
        };

        return (
            <>
                <Component {...props} />
                <EmailUnsubscribeModalContainer
                    isLoading={signalsAlertsCancellationMutation.isPending}
                    onConfirm={handleConfirmUnsubscribe}
                />
            </>
        );
    };
};

export default withSignalsSubscription;
